import { ErrorPagesInfo } from "constants/error_pages";
import { PageProps, PageWithLayout } from "@types";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import CallIcon from "@svg/contact-us/call-icon";
import MessageIcon from "@svg/contact-us/message";

// pages/500.js
interface Props extends PageProps {}

const ErrorPage500: PageWithLayout<Props> = () => {
  return (
    <div className="mt-16 w-full">
      <div className=" container-bs">
        <div className=" flex w-full flex-col items-center">
          <div className="mb-6 md:mb-5">
            <img
              src={ErrorPagesInfo[500].image}
              alt="500"
              className="h-[160px] lg:h-[270px] w-auto"
            />
          </div>
          <div>
            <h2 className="headline-sm md:headline-md text-center mb-2.5 text-fds-primary">
              {ErrorPagesInfo[500].title}
            </h2>
            <p className="body-md md:body-lg text-fds-secondary text-center max-w-[296px] md:max-w-[572px]">
              {ErrorPagesInfo[500].subtitle}
            </p>
          </div>
          <div className="mt-6 w-full flex justify-center items-center gap-3 md:gap-6">
            <div className="grow max-w-[232px] p-3 rounded-8 border bg-fds-canvas-secondary border-fds-brand-light flex items-center justify-center gap-2 flex-col">
              <div className="w-8 h-8 relative">
                <MessageIcon className="w-6 text-fds-icon-brand absolute z-10 left-0 top-0" />
                <div className="w-6 h-6 rounded-full bg-fds-brand-light absolute bottom-0 right-1" />
              </div>
              <p className="text-fds-secondary title-md-medium md:title-lg text-center">
                info@faradars.org
              </p>
            </div>
            <div className="grow max-w-[232px] p-3 rounded-8 border bg-fds-canvas-secondary border-fds-brand-light flex items-center justify-center gap-2 flex-col">
              <div className="w-8 h-8 relative">
                <CallIcon className="w-6 text-fds-icon-brand absolute z-10 left-0 top-0" />
                <div className="w-6 h-6 rounded-full bg-fds-brand-light absolute bottom-0 right-1" />
              </div>
              <p className="text-fds-secondary title-md-medium md:title-lg text-center">
                ۰۲۱-۵۷۹۱۶۰۰۰ (تهران)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorPage500.getLayout = (page, props) =>
  getDefaultLayout(
    page,
    { ...props },
    {
      footerProps: {
        showAdsFooter: false,
        showAppFooter: false,
        showButtonOrganizationFooter: false,
        showHomeAppFooter: false,
        showLinkFooter: false,
        showMainFooter: false,
        showOrganizationFooter: false,
        showValuesFooter: false,
      },
    }
  );
export default ErrorPage500;
